import { IAppState } from '../common/state';

export const getJsonQuery = ({ filters: { jsonQuery } }: IAppState) => {
  return jsonQuery;
};
